// extracted by mini-css-extract-plugin
export default {"form":"TaskinfoForm_form__Fg7uc"};